import { max as d3Max } from 'd3'

import { $i18n } from './localization'

export const getUnitLabel = dataset => {
  if (dataset.unit === 'byte' || dataset.dataValue === 'max_memory_level_gradient') {
    if (dataset.lines && dataset.lines.length > 0) {
      const max = d3Max(dataset.lines, function(d) {
        return d3Max(d.items, function(d2) {
          return d2.value + (d2.value * 10) / 100
        })
      })
      return dataset.dataValue === 'max_memory_level_gradient'
        ? getByteUnitOverTime(max)
        : getByteUnit(max)
    } else {
      return 'Byte'
    }
  } else {
    return $i18n('unit.' + dataset.unit)
  }
}

export const getByteRound = value => {
  if (value) {
    if (value == 0) return 0
    const i = parseInt(Math.floor(Math.log(value) / Math.log(1024)))
    return Number(Number(value / Math.pow(1024, i)).toFixed(1))
  } else {
    return 0
  }
}

export const getByteUnit = value => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (!value || value === 0) return 'Byte'
  const i = parseInt(Math.floor(Math.log(value) / Math.log(1024)))
  return sizes[i]
}

export const getByteUnitOverTime = value => {
  return getByteUnit(value) + ' / min'
}
